// extracted by mini-css-extract-plugin
module.exports = {"fallback":"Fallback_fallback__3rW53","icon":"Fallback_icon__2uFDx","description":"Fallback_description__2j12W"};